var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"id":"core-toolbar","color":"primary","dark":"","extended":"","flat":""}},[_c('v-spacer'),_c('v-btn',{staticStyle:{"z-index":"9"},attrs:{"icon":"","to":"/logout"}},[_c('v-icon',[_vm._v("mdi-export")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }